<!--    The Button that represents a Device / CompoundMeter in the Device List 
        In The Case of CompoundMeters it only displays The Data of the main Watermeter in that configuration    -->
<!--Copy right - © 2024 tecera gmbh-->

<script>
    import { slide } from "svelte/transition";
    import {
        selected_device,
        modal_mode,
        is_modal_open,
        current_device_data,
    } from "../../stores.js";
    import { find_main_meter } from "../../scripts/utils.js";
    import DeviceButtonDataLine from "./buttons_parts/DeviceButtonDataLine.svelte";
    import { onMount } from "svelte";

    export let device_config;
    export let multiple_devices = false;
    export let is_dummy_device = false;

    let is_open = false;
    let buttonElement;
    let main_meter;
    let status = "Aktiv";

    onMount(() => {
        if (multiple_devices && device_config) {
            main_meter = find_main_meter(device_config);
        }
    });

    $: {
        if (multiple_devices && $selected_device) {
            main_meter = find_main_meter(device_config);
        }
    }

    $: if (!is_dummy_device) {
        if (multiple_devices) {
            if (main_meter) {
                status = main_meter.active === 1 ? "Aktiv" : "Inaktiv";
            } else {
                status = "Inaktiv";
            }
        } else {
            status = device_config.active === 1 ? "Aktiv" : "Inaktiv";
        }
    } else {
        status = device_config.status === "active" ? "Aktiv" : "Inaktiv";
    }

    $: {
        if ($selected_device === device_config) {
            is_open = true;
            if (buttonElement) {
                buttonElement.scrollIntoView({ behavior: "smooth",block: "nearest"}); //TODO: disable on low width
            }
        } else {
            is_open = false;
        }
    }
    let last_values = {};
    let last_sum = 0;

    $: if ($selected_device === device_config && $current_device_data) {
        last_values = $current_device_data.map((data) => {
            return { id: data.config_id, data: data.last_data?.meter_reading };
        });
        last_sum = sum_data();
    }

    function sum_data() {
        let sum = 0;
        last_values.forEach((data) => {
            sum += data.data;
        });
        return sum;
    }
    //TODO: clean up code
</script>

{#if !multiple_devices || main_meter}
<button
    on:click={() => {
        if ($selected_device === device_config) {
            is_open = !is_open;
        } else {
            $selected_device = device_config;
        }
    }}
    type="button"
    bind:this={buttonElement}
    class="btn btn-normal btn-transparent btn-block mt-0"
    ><div class="row bold">
        <div class="col-7 text-left" >
            <p style="white-space: pre-line;" class="mb-0">
                {multiple_devices
                    ? main_meter.sub_id + " - " + main_meter.name
                    : device_config.name || "unbennantes Gerät"}
            </p>
        </div>
        <div class="col-3 text-left">{status}</div>
        <div class="col-2 text-right">
            <i
                class="arrow active {is_open ? 'up' : 'down'}"
            ></i>
        </div>
    </div>
</button>

{#if is_open}
    <div id="direkt-3sensoren_alive_20sec" transition:slide|local>
        <div class="gray">
            {#if !multiple_devices}
                <DeviceButtonDataLine
                    label="Dev_eui:"
                    value={device_config.dev_eui
                        ? device_config.dev_eui
                        : device_config.box_id}
                />
            {/if}
            <DeviceButtonDataLine
                label="Einbauort:"
                value={multiple_devices
                    ? main_meter.location
                    : device_config.location}
            />
            <DeviceButtonDataLine
                label="Ortsteil:"
                value={multiple_devices
                    ? main_meter.district
                    : device_config.district}
            />
            <DeviceButtonDataLine
                label="Straße:"
                value={multiple_devices
                    ? main_meter.street
                    : device_config.street}
            />
            <DeviceButtonDataLine label="Status:" value={status} />
            <DeviceButtonDataLine
                label="Bemerkungen:"
                value={multiple_devices
                    ? main_meter.comment
                    : device_config.comment}
            />
            {#if multiple_devices}
                {#if main_meter.compound_role === "main"}
                    {#each device_config.watermeterconfigs as meter}
                        {#if meter.compound_role === "sub"}
                            <div class="row">
                                <div class="col-6">
                                    {"Nebenzähler-ID:"}
                                </div>
                                <div class="col-6">
                                    {meter.sub_id}
                                </div>
                            </div>
                        {/if}
                    {/each}
                    <div class="row">
                        <div class="col-6">
                            {"Zählerstand Gesamt:"}
                        </div>
                        <div class="col-6">
                            {#if last_sum === 0}
                                {""}
                            {:else}
                                {last_sum.toFixed(3) + " m³"}
                            {/if}
                        </div>
                    </div>

                    {#each device_config.watermeterconfigs as meter}
                        <div class="row">
                            <div class="col-6">
                                {meter.compound_role === "main"
                                    ? "Hauptzähler:"
                                    : "Nebenzähler:"}
                            </div>
                            <div class="col-6">
                                {last_values.find(
                                    (data) => data.id === meter.id,
                                )?.data === undefined
                                    ? ""
                                    : last_values.find(
                                          (data) => data.id === meter.id,
                                      )?.data + " m³"}
                            </div>
                        </div>
                    {/each}
                {:else}
                    {#each device_config.watermeterconfigs as meter}
                        <DeviceButtonDataLine
                            label={"Haupzähler:"}
                            value={last_values.find(
                                (data) => data.id === meter.id,
                            )?.data === undefined
                                ? ""
                                : last_values.find(
                                      (data) => data.id === meter.id,
                                  )?.data + " m³"}
                        />
                    {/each}
                {/if}
            {/if}

            <div class="row">
                <div class="col">
                    <button
                        class="btn btn-normal btn-transparent btn-underline gray bold"
                        on:click={() => {
                            $modal_mode = "edit";
                            $is_modal_open = true;
                        }}>Bearbeiten</button
                    >
                </div>
            </div>
        </div>
    </div>
{/if}
{/if}
